import { useParams } from 'react-router-dom';
import { Hammer } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';
import { PageHeader } from '@/components/PageHeader';
import { findNavItem } from '@/navigation';
import { NotFoundPage } from './NotFoundPage';

/**
 * 年度配下の未定義パス。navigation.ts に「準備中」として登録済みなら準備中表示、それ以外は 404。
 */
export function PlannedPage() {
  const params = useParams();
  const rest = params['*'] ?? '';
  const found = findNavItem(rest);
  if (!found || found.item.status !== 'planned') return <NotFoundPage />;
  return (
    <>
      <PageHeader eyebrow={found.group?.label} title={found.item.label} />
      <div className="bs-panel">
        <EmptyState
          icon={<Hammer />}
          title="この画面は準備中です"
          description={
            <>
              「{found.item.label}」は現在移行作業中です。
              {found.item.description && (
                <>
                  <br />
                  {found.item.description}
                </>
              )}
            </>
          }
        />
      </div>
    </>
  );
}
